"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exportComponents;
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _server = _interopRequireDefault(require("react-dom/server"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * Wrap a component with the react-interop API methods
 * @param {function} Component React component type to wrap
 * @param {function} Container Optional React component type to use as a container
 * @param {object} containerProps Optional props for the container
 * @return {object} An object with render and renderToStaticMarkup methods
 */
function wrapComponent(Component, Container, containerProps) {
  return {
    createElement: function createElement(componentProps) {
      var component = /*#__PURE__*/_react["default"].createElement(Component, componentProps);

      // If there is a Container type, then wrap the component in
      // a container element, providing the container its props
      if (Container) {
        return /*#__PURE__*/_react["default"].createElement(Container, _extends({}, containerProps, {
          children: component
        }));
      }
      return component;
    },
    render: function render(props, container) {
      if (typeof container === 'string') {
        container = document.getElementById(container);
      }
      _reactDom["default"].render(this.createElement(props), container);
    },
    renderToStaticMarkup: function renderToStaticMarkup(props) {
      return _server["default"].renderToStaticMarkup(this.createElement(props));
    }
  };
}

/**
 * Export React components for interop rendering
 * @param {object} componentTypes Each property is a React component type to be exported
 * @param {function} Container Optional React component type to use as a container
 * @param {object} containerProps Optional props for the container
 * @return {object} An object with properties for each React component type exported, each of those having render and renderToStaticMarkup methods
 */
function exportComponents(componentTypes, Container, containerProps) {
  var exported = {};
  function exportComponent(key, componentType) {
    if (componentType && (typeof componentType === 'function' || _typeof(componentType) === 'object')) {
      exported[key] = wrapComponent(componentType, Container, containerProps);
    }
  }
  if (componentTypes) {
    Object.keys(componentTypes).forEach(function (key) {
      return exportComponent(key, componentTypes[key]);
    });
  }
  return exported;
}